import React, { useEffect } from "react";
import { SubTaskActionUpdateFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Inputs } from "components";
import { MdAssignmentAdd } from "react-icons/md";
import { SERVICES_SUB_TASK_RENDER_PROMOTION } from "utils/functions/serviceTask";
import moment from "moment";
import { portalService } from "apiServices";

const SubTaskActionUpdateForm = ({
  initialValues,
  mainTaskID,
  permission,
  onSubmit,
  onCancel,
  onEdit,
}) => {
  const schema = yup.object().shape({
    // name: yup.string().required("Reward Name is required"),
    // description: yup.string().required("Description Name is required"),
    // type: yup.string().required("Reward Type is required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (initialValues) {
      reset({
        ...initialValues,
      });
    }
  }, [initialValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const watchAllField = watch();
  const watchIsCallConfirmField = watch("is_call_confirm");

  return (
    <SubTaskActionUpdateFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="body_form_campaign">
          <div className="f_title">
            {initialValues.sub_task_code} (
            {SERVICES_SUB_TASK_RENDER_PROMOTION(initialValues.promotion_type)})
          </div>
          <div className="input_warp">
            <div className="left_box">
              <div className="left_col">Appointment date</div>
            </div>
            <div className="right_box">
              <div className="w20">
                {moment(initialValues.appointment_date).format("DD MMMM YYYY")}
              </div>
              <div className="w20">{initialValues.appointment_time}</div>
              <div
                onClick={() => onEdit(initialValues)}
                style={{ cursor: "pointer" }}
                className="w20"
              >
                <MdAssignmentAdd size={22} color="#F89900" />
              </div>
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Call Confirm on</div>
            <div className="right_box">
              <div className="w20">
                {moment(initialValues.appointment_date)
                  .subtract(1, "day")
                  .format("DD MMMM YYYY")}
              </div>
              <div className="w20">
                {watchIsCallConfirmField ? "Yes" : "No"}
              </div>
              <div className="w20">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.InputSwitchAlertApi
                      {...field}
                      apiService={portalService.PUT_SUB_TASK_UPDATE}
                      idUpdate={initialValues._id}
                      initialParams={{ main_task_ref_id: mainTaskID }}
                      fieldUpdate="is_call_confirm"
                      disabled={watchAllField.is_call_confirm}
                      errors={errors.is_call_confirm?.message}
                    />
                  )}
                  name="is_call_confirm"
                  defaultValue={false}
                />
              </div>
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Service Completed</div>
            <div className="right_box">
              {initialValues.service_complete_date && (
                <>
                  <div className="w20">
                    {moment(initialValues.service_complete_date).format(
                      "DD MMMM YYYY"
                    )}
                  </div>
                  <div className="w20">
                    {moment(initialValues.service_complete_date).format(
                      "HH:mm"
                    )}
                  </div>
                </>
              )}
              <div className="w20">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.InputSwitchAlertApi
                      {...field}
                      apiService={portalService.PUT_SUB_TASK_UPDATE}
                      idUpdate={initialValues._id}
                      initialParams={{ main_task_ref_id: mainTaskID }}
                      fieldUpdate="is_service_complete"
                      errors={errors.is_service_complete?.message}
                    />
                  )}
                  name="is_service_complete"
                  defaultValue={false}
                />
              </div>
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Next call - Follow up</div>
            <div className="right_box">
              {initialValues.service_complete_date && (
                <>
                  <div className="w20">
                    {moment(initialValues.service_complete_date)
                      .add(5, "month")
                      .format("DD MMMM YYYY")}
                  </div>
                  <div className="w20">
                    {moment(initialValues.service_complete_date)
                      .add(5, "month")
                      .format("HH:mm")}
                  </div>
                </>
              )}
              <div className="w20">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.InputSwitchAlertApi
                      {...field}
                      errors={errors.is_next_call?.message}
                    />
                  )}
                  name="is_next_call"
                  defaultValue={false}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </SubTaskActionUpdateFormStyled>
  );
};

SubTaskActionUpdateForm.propTypes = {};

export default SubTaskActionUpdateForm;
